module.exports = __webpack_public_path__ + "img/tick.580045fd.svg";